const doc = [({"da":({"js":({"users":({"edit":({"form":({"relatives":({"add_relative":"Tilføj pårørende"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;